import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'publisher/reducers/optInReducer'

export { selectors }

export default function useOptIn(selector) {
  return useSelector(state => selector(state.optIn), shallowEqual)
}